import type { WorkOrderWeather } from '../types/worklog.types';

/**
 * 날짜 그룹 머리 날씨 — 공사현황(E)·작업요청이력(B-1) 공용.
 *
 * 그 날짜 작업요청 중 **날씨명이 있는 가장 이른 요청**의 스냅샷(요청 시점 기준)을 고른다. 첫 요청의 날씨 수집이 실패했거나
 * (위경도 없음·조회 실패) 수집 도입 이전 건이면 같은 날 다음 요청의 값을 쓴다.
 */
export function pickGroupWeather<T>(
  items: T[],
  weatherOf: (item: T) => WorkOrderWeather | null | undefined,
  timeOf: (item: T) => string,
): WorkOrderWeather | null {
  let best: { weather: WorkOrderWeather; time: string } | null = null;
  for (const item of items) {
    const weather = weatherOf(item);
    // 머리에 보여줄 날씨명이 없는 스냅샷은 건너뛴다
    if (!weather?.weatherName) continue;
    const time = timeOf(item);
    if (!best || time < best.time) best = { weather, time };
  }
  return best?.weather ?? null;
}

/**
 * 날짜 그룹 머리 날씨 표시 — 아이콘(BE가 내려주는 weatherIcon) + 날씨명. 기온은 표시하지 않는다.
 * 실측이 아니라 작업요청 시점 기준이라 툴팁으로 알린다. 아이콘 표시는 작업요청 작성 화면 날씨바와 같은 방식이다.
 */
export function GroupWeather({ weather }: { weather: WorkOrderWeather }) {
  return (
    <span className="flex shrink-0 items-center gap-02 text-caption font-medium text-text-muted" title="작업요청 시점 기준 날씨">
      {weather.weatherIcon && <span className="text-base leading-none" aria-hidden>{weather.weatherIcon}</span>}
      {weather.weatherName}
    </span>
  );
}
